import axios from 'axios'
import FilialDataService from '@/services/api/FilialDataService'

const state = {
  loadingList: false,
  branches: [],
  allBranches: [],
  singleBranch: null,
  currentBranch: null,
  availableForOrderFilials: [],
}

const getters = {
  getLoadingListState (state) {
    return state.loadingList
  },
  getBranches (state) {
    return state.branches
  },
  getAllBranches (state) {
    return state.allBranches
  },
  getSingleBranch (state) {
    return state.singleBranch
  },
  getLocalStorageBranch (state) {
    const filial = localStorage.getItem('filial')
    if (filial) {
      try {
        return JSON.parse(filial)
      } catch (e) {
        console.error(e)
        return {}
      }
    }
    return {}
  },
  getGlobalFilial (state, getters) {
    return getters.getLocalStorageBranch
  },
  getGlobalFilialId (state, getters) {
    return getters.getLocalStorageBranch?.id
  },
  getGlobalFilialName (state, getters) {
    return getters.getLocalStorageBranch?.name
  },
  getGlobalFilialShortName (state, getters) {
    return getters.getLocalStorageBranch?.shortName
  },
  getGlobalFilialIsCallCenter (state, getters) {
    return !!getters.getGlobalFilial?.isCallCenter
  },
}

const mutations = {
  setLoadingListState (state, value) {
    state.loadingList = !!value
  },
  setBranches (state, payload) {
    state.allBranches = payload
    state.branches = payload
      // .filter((ell) => ell.status)

    state.currentBranch = state.branches[0] || null
    if (!localStorage.getItem('filial')) {
      localStorage.setItem('filial', JSON.stringify(state.currentBranch))
    }
  },
  setSingleBranch (state, payload) {
    state.singleBranch = payload
  },
  clearSingleBranch (state) {
    state.singleBranch = null
  },
  setCurrentBranch (state, value) {
    state.currentBranch = value
    localStorage.setItem('filial', JSON.stringify(value))
  },

  setAvailableForOrderFilials (state, data) {
    state.availableForOrderFilials = data
  },
}

const actions = {
  fetchBranches ({ commit, rootGetters }, meta) {
    commit('setLoadingListState', true)
    meta = meta || {
      limit: 100000,
      offset: 0,
      page: 1,
    }
    return axios
      .get(
        `${rootGetters['api/filialsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setBranches', res.data.items)

        return res
      })
      .catch((err) => err)
      .finally(() => {
        commit('setLoadingListState', false)
      })
  },
  fetchSingleBranch ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/filialsSingle'](id))
      .then((res) => {
        commit('setSingleBranch', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createBranch ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/filialsCreate'], data)
      /* .then((res) => {
        return res
      })
      .catch((err) => err) */
  },
  editBranch ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/filialsEdit'](id), data)
      /* .then((res) => {
        return res
      })
      .catch((err) => err) */
  },
  deleteBranch ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/filialsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getBranches.filter((val) => val.id !== id)
          commit('setBranches', items)
        }

        return res
      })
      .catch((err) => err)
  },

  fetchAvailableForOrderFilials ({ commit }) {
    return FilialDataService.getAvailableForOrder()
      .then(data => {
        commit('setAvailableForOrderFilials', data)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
